exports = module.exports = require("../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".header-dasboard-admin{\n    text-align: center;\n    height: 40px;\n    display: flex;\n    flex-direction: row;\n    background-color: #cfd1d2;\n}\n.container-userFind-dasboard{\n    width: 600px;\n}", ""]);

